import Link from 'next/link';
import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  href: string;
  className?: string;
  onClickBackLink?: (e: React.UIEvent<Element, UIEvent>) => void;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtBackLink = ({ children, href, className, onClickBackLink }: Props) => {
  return (
    <div className={`atbacklink ${className}`}>
      <Link href={href} target='_self' onClick={onClickBackLink}>
        {children}
      </Link>
    </div>
  );
};
/** 初期値の設定 */
AtBackLink.defaultProps = {
  className: '',
  onClickBackLink: null,
};
export default AtBackLink;
